export default __webpack_public_path__ + "static/desktop_menu_KV06-08270afa7b84369c5c72a0a329fbcacf.mp4";